import { IGetters } from './getters.types'
import { IvalidationData } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants';
import {Utilities as _utils} from '@/shared/utilities';

export const getters: IGetters = {
    getSectionWiseValidation(state: IvalidationData,section: string)
    {
        let data=state.validationMessages.filter(x=>x.SectionKey==section)
        return data;
    },
    getSectionCount(state: IvalidationData,section: string)
    {
        let data=state.validationMessages.filter(x=>x.SectionKey==section)
        console.log(data)
        return data.length;
    }
}